module.exports = __webpack_public_path__ + "static/media/errorPhoto.484b9ec0.png";